var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{ref:"notification",staticClass:"recharge-notification"},[_c('div',{staticClass:"sparkles"}),_c('div',{ref:"coinRef",staticClass:"coin"},[_vm._v("💰")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"amount"},[_vm._v("+"+_vm._s(_vm.amount)+"金币")]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.notice))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }